<a [routerLink]="['/discipline']" [queryParams]="{discid: disc.id}" routerLinkActive="router-link-active">
  <div  class="group p-6 shadow dark:shadow-gray-700 rounded-md bg-white hover:bg-earth-dark/20 dark:bg-slate-900 dark:hover:bg-emerald-600/10 text-center transition-all duration-500">
    <div class="w-16 h-16 flex items-center justify-center mx-auto bg-earth-try/20 group-hover:bg-earth-dark dark:bg-emerald-600/10 dark:group-hover:bg-emerald-600 shadow dark:shadow-gray-700 rounded-lg transition-all duration-500">
      <!--<i class="uil uil-phone text-[30px] text-earth-xdark group-hover:text-white"></i>-->
      <img class="object-cover w-16 h-16 rounded-lg" [src]="disc.pic" />
    </div>

    <div class="mt-4">
      <a [routerLink]="['/discipline']" [queryParams]="{discid: disc.id}" routerLinkActive="router-link-active" class="text-lg font-semibold text-black/70 transition-all duration-500">{{disc.naam}}</a>

      <p class="text-slate-400 mt-3 mb-2">{{disc.korte_omschrijving}}</p>

      <a [routerLink]="['/discipline']" [queryParams]="{discid: disc.id}" routerLinkActive="router-link-active" class="hover:text-emerald-600 font-medium transition-all duration-500">Meer info <i class="uil uil-arrow-right"></i></a>
    </div>
  </div><!--end content-->
</a>
